/****************************************************
 * Module Name:  tableIncProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class TableIncProxy {
    static GetAllTableInc = (callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/tableinc",
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetSingleTableInc = (Id, callback) => {
        let params = {
            id: Id,
        };

        restAPICall(
            Constants.MANAGER_URL + "/tableinc",
            "get",
            Constants.userToken,
            params,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetAllTableIncMini = (callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/tableinc/mini",
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };


    static CheckTableIncAvailable = (tableinc, callback) => {
        let params = {
            tableinc: tableinc,
        };

        restAPICall(
            Constants.MANAGER_URL + "/tableinc/available",
            "get",
            Constants.userToken,
            params,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static AddTableInc = (tableinc, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/tableinc",
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(tableinc),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static UpdateTableInc = (tableinc, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/tableinc",
            "put",
            Constants.userToken,
            undefined,
            JSON.stringify(tableinc),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static DeleteTableInc = (tableinc, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/tableinc",
            "delete",
            Constants.userToken,
            undefined,
            JSON.stringify(tableinc),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };
}
